var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlumniad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.83307 10.225V13.325L9.99974 15.6L14.1664 13.325V10.225L9.99974 12.5L5.83307 10.225ZM4.31641 7.50002L9.99974 10.6L15.6831 7.50002L9.99974 4.40002L4.31641 7.50002Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 2.5L0.833008 7.5L4.16634 9.31667V14.3167L9.99967 17.5L15.833 14.3167V9.31667L17.4997 8.40833V14.1667H19.1663V7.5L9.99967 2.5ZM14.1663 13.325L9.99967 15.6L5.83301 13.325V10.225L9.99967 12.5L14.1663 10.225V13.325ZM9.99967 10.6L4.31634 7.5L9.99967 4.4L15.683 7.5L9.99967 10.6Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumniad);
export default __webpack_public_path__ + "static/media/alumniad.1ee31097c96841e3351cb4ec4f62d688.svg";
export { ForwardRef as ReactComponent };